import { Alert, Dialog, Grid, IconButton } from "@mui/material";
import React, { useState } from "react";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import { MyButton } from "../../../components/my-button/MyButton";
import { EmailRegExp, UserRoles, ValidPasswordRegExp, ValidUsernameRegExp } from "../../../Constant";
import { MyDropdown } from "../../../components/my-dropdown/MyDropdown";
import AccountApiService from "../../../adapters/xhr/AccountApiService";

export const AddAccount = (props) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [role, setRole] = useState(null);
  const [roleValueErr, setRoleValueErr] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");
  const [userNameValueErr, setUserNameValueErr] = useState("");
  const [emailValueErr, setEmailValueErr] = useState("");
  const [emailConfirmValueErr, setEmailConfirmValueErr] = useState("");
  const UserRoleOptions = [
    { label: t("super_admin"), key: UserRoles.SuperAdmin, value: t("super_admin") },
    { label: t("system_admin"), key: UserRoles.SystemAdmin, value: t("system_admin") },
    { label: t("case_manager"), key: UserRoles.CaseManager, value: t("case_manager") },
  ];

  const submit = async () => {
    let isValid = true;
    let validEmail = new RegExp(EmailRegExp);
    if (email.trim() && !validEmail.test(email.trim())) {
      setEmailValueErr(t("invalid"));
      isValid = false;
    } else if (email != emailConfirm) {
      setEmailValueErr("");
      setEmailConfirmValueErr(t("email_confirm_not_match"));
      isValid = false;
    } else {
      setEmailConfirmValueErr("");
      setEmailValueErr("");
    }

    if (!role) {
      setRoleValueErr(t("required"));
      isValid = false;
    } else {
      setRoleValueErr("");
    }

    if (!userName.trim()) {
      setUserNameValueErr(t("required"));
      isValid = false;
    } else {
      setUserNameValueErr("");
    }

    if (isValid) {
      let payload = {
        email: email,
        userName: userName,
        role: role.key,
      };
      let response = await AccountApiService.addAccount(payload);
      if (response && response.isSuccess) {
        props.onClose(true);
      } else if (response && response.errorMessage) {
        try {
          const validationErrors = JSON.parse(response.errorMessage);
          const error = Object.keys(validationErrors).map(key => t(validationErrors[key])).join(", ");
          setMessage(error);
        }
        catch (err) {
          setMessage(t("error"));
        }
      } else {
        setMessage(t("error"));
      }
    }
  };
  return (
    <Dialog fullScreen open={props.open} onClose={props.onClose}>
      <MuiDialogTitle>
        <IconButton aria-label="close" style={{ float: "right" }} onClick={(e) => props.onClose(false)}>
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
      <Grid container justifyContent="center" className="container custom">
        <Grid item className="padding left-1 right-1">
          <h1 className="margin top-0 bottom-0">{t("add_account").toUpperCase()}</h1>
          <MyTextField label={t("username")} value={userName} onChange={(value) => setUserName(value)} helperText={userNameValueErr} />
          <MyTextField
            label={t("email")}
            value={email}
            onChange={(value) => setEmail(value.toLowerCase())}
            regExp={ValidUsernameRegExp}
            helperText={emailValueErr}
          />
          <MyTextField
            label={t("confirm_email")}
            value={emailConfirm}
            onChange={(value) => setEmailConfirm(value.toLowerCase())}
            regExp={ValidUsernameRegExp}
            helperText={emailConfirmValueErr}
          />
          <MyDropdown options={UserRoleOptions} helperText={roleValueErr} onChange={(e, value) => setRole(value)} label={t("role")} value={role} />
          <MyButton className="margin bottom-1 top-0" onClick={(e) => submit()} text={t("submit")} />
          {message && (
            <Alert variant="filled" severity="error" className="margin top-1 bottom-1">
              {message}
            </Alert>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
};
